import { configureStore } from '@reduxjs/toolkit'
import itinerarySlice from './itinerarySlice'

export const ReduxStore = configureStore({
  reducer: {
    itinerary:itinerarySlice,
  },
})